import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";

import { DottedArrowRight } from "../../../../components/svg/svgImageList";
import Button from "../../../../components/button/Button";
import WarningBeforeAction from "../../../../components/data-components/WarningBeforeAction";
import useThemeService from "../../../../services/theme-service/ThemeService";
import { translationService } from "../../../../services/translation/TranslationService";
import useModal from "../../../../components/dialog/useModal";
import useErrorHandler, {
  ApplicationError,
} from "../../../../services/error-handler/ErrorHandlerService";
import { JobActionProps } from "./JobActionProps";

export const MarkAsInProgressButton = observer(
  ({ disabled = true, isHidden, currentJobStorage }: JobActionProps) => {
    const { isVisible, toggleModal } = useModal();
    const { themeClass } = useThemeService();
    const { handleErrorInSnackbar } = useErrorHandler();

    const doAction = useCallback(async () => {
      try {
        await currentJobStorage.markJobInProgress();
      } catch (error) {
        const applicationError = error as ApplicationError;
        applicationError.withErrorMessage("default-error.job.change-status");
        handleErrorInSnackbar(applicationError);
      }
      toggleModal();
    }, [toggleModal, currentJobStorage, handleErrorInSnackbar]);

    return (
      <>
        <Button
          id="mark-as-in-progress"
          disabled={disabled}
          isHidden={isHidden}
          icon={{
            svg: DottedArrowRight,
            textKey: "jobs.MarkAsInProgressButton.label",
            textClass: "actions-header-button-label",
            className: themeClass(["icon-mark-as-in-progress"]),
          }}
          onClick={toggleModal}
        />
        <WarningBeforeAction
          titleKey="jobs.MarkAsInProgressButton.warning-question"
          buttonOk={{
            id: "ok-mark-job",
            textKey: "jobs.MarkAsInProgressButton.label",
            action: doAction,
          }}
          isVisible={isVisible}
          toggleModal={toggleModal}
        >
          <p>{translationService.translate("jobs.MarkAsInProgressButton.are-you-sure-line1")}</p>
          <p>{translationService.translate("jobs.confirmation-action-change-information")}</p>
        </WarningBeforeAction>
      </>
    );
  }
);
